import styled from 'styled-components'

export const SelectComponent = styled.select`
  box-shadow: 2px 2px 5px #30303090;
  border-radius: 5px;
  padding: 8px 15px;
  outline: none;
`
